import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';

const lightbox = new PhotoSwipeLightbox({
    gallery: 'body',
    children: 'a.lightbox',
    hideAnimationDuration: 10,
    paddingFn: (viewportSize) => {
        return {
            // check based on viewport size
            bottom: viewportSize.x < 1000 ? 0 : 100,
            top: viewportSize.x < 1000 ? 0 : 100,
        };
    },
    pswpModule: PhotoSwipe,
});

lightbox.init();
